var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Events',{attrs:{"editMode":_vm.hasRole(_vm.roles_.teacher)}})}
var staticRenderFns = []

export { render, staticRenderFns }